import { z } from 'zod';

export const shiftConfirmationTypeSchema = z.enum(['confirmed', 'declined', 'pending']);

export type ShiftConfirmationType = z.infer<typeof shiftConfirmationTypeSchema>;

export const shiftConfirmationQuerySchema = z.object({
  // Pagination
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).optional(),

  // Confirmation type filter
  type: shiftConfirmationTypeSchema.optional(),

  // Relationship filters
  campaign_id: z.string().uuid().optional(),

  // Date filter (YYYY-MM-DD)
  date: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),

  // Text search on phone_number
  search: z.string().optional(),

  // Sorting
  sortBy: z.enum(['executed_at']).default('executed_at'),
  sortOrder: z.enum(['asc', 'desc']).default('desc'),
});

export type ShiftConfirmationQuery = z.infer<typeof shiftConfirmationQuerySchema>;
